import Button from '@components/Button/Button';
import { RedirectIcon } from '@/components/MenusIcons/MenusIcons';

interface QuickLinkProps {
  title: string;
  description?: string;
  linkUrl?: string;
  buttonText: string;
  linkTarget?: '_blank' | '_self';
  className?: string;
}

function quickLinkShowsExternalIcon(linkUrl?: string, linkTarget?: '_blank' | '_self'): boolean {
  if (linkTarget === '_blank') return true;
  const url = linkUrl?.trim();
  return Boolean(url && /^https?:\/\//i.test(url));
}

export default function QuickLink({
  title,
  description,
  linkUrl,
  buttonText,
  linkTarget,
  className,
}: QuickLinkProps) {
  const showExternalIcon = quickLinkShowsExternalIcon(linkUrl, linkTarget);

  return (
    <div className={`quick-link ${className ?? ''}`.trim()}>
      <h3 className="quick-link__title">{title}</h3>
      {description ? <p className="quick-link__description">{description}</p> : null}
      <Button
        label={buttonText}
        linkUrl={linkUrl}
        linkTarget={linkTarget}
        icon={showExternalIcon ? <RedirectIcon /> : undefined}
        iconPosition={showExternalIcon ? 'after' : undefined}
        className="quick-link__btn"
      />
    </div>
  );
}
